<ng-container *ngIf="showSearchButton; else defaultSearchTemplate">
  <div class="search-wrapper with-submit-mode">
    <label class="search-label" *ngIf="searchVisible && !searchValue">Search</label>
    <label class="search-label clickable" (click)="open()" *ngIf="!searchVisible">Search</label>

    <mat-form-field class="mat-search_field" [@slideInOut]="searchVisible">
        <input style="font-size: 14px;" #input matInput type="text" [placeholder]="" [value]="searchValue" (input)="searchValue = input.value" (keyup.enter)="onEnter($event)" />
    </mat-form-field>

    <button class="search-submit-button" mat-raised-button color="primary" *ngIf="searchVisible" (click)="triggerSearch(input.value)">
      Search
    </button>

    <button class="submit-mode-icon-button" mat-icon-button *ngIf="searchVisible" (click)="close()" aria-label="Close search">
      <mat-icon>close</mat-icon>
    </button>
    <button class="submit-mode-icon-button" mat-icon-button *ngIf="!searchVisible" (click)="open()" aria-label="Open search">
      <mat-icon>search</mat-icon>
    </button>
  </div>
</ng-container>

<ng-template #defaultSearchTemplate>
  <div>
    <label style="padding-right: 200px; font-size: 13px !important;" *ngIf="searchVisible && !searchValue">Search</label>
    <label style="padding-right: 30px; font-size: 13px !important;" (click)="open()" *ngIf="!searchVisible">Search</label>
  </div>
  <mat-form-field class="mat-search_field" [@slideInOut]="searchVisible">
      <input style="font-size: 14px;" #input matInput type="text" [placeholder]="" [value]="searchValue" (input)="searchValue = input.value" (keyup.enter)="onEnter($event)" />
  </mat-form-field>
  <span class="mat-search_icons" [class.mat-search_icons--active]="searchVisible">
    <mat-icon class="mat-search_icon-close" *ngIf="searchVisible" (click)="close()" matRipple>close</mat-icon>
    <mat-icon class="mat-search_icon-search" *ngIf="!searchVisible" (click)="open()" matRipple>search</mat-icon>
  </span>
</ng-template>
